/** A Trading Arrival's read-only details; static only because `trading/` already owns the path. */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { ArrivalDetailsPage } from "@/features/arrival/components/details/arrival-details-page";
import { useAuth } from "@/features/auth/store";

export const Route = createFileRoute("/_app/arrivals/trading/$id_/details")({
  params: {
    parse: ({ id }) => {
      if (!/^\d+$/.test(id)) throw notFound();
      return { id };
    },
    stringify: (p) => p,
  },
  beforeLoad: () => {
    const auth = useAuth.getState();
    if (!auth.can("document.view") || !auth.canViewForm("arrival_trading"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <ArrivalDetailsPage id={Number(id)} />;
}
